import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import 'react-phone-input-2/lib/style.css';
import LeaseApiService from '../../services/apiService';

const AddressDetails = ({ setAddressList, countriesList, addressList, addAddressType, readOnly = false }) => {
    const apiService = new LeaseApiService();
    const [editIndex, setEditIndex] = useState(null);
    const [cityList, setCityList] = useState([]);

    const [formData, setFormData] = useState({
        type: null,
        poBox: '',
        address1: '',
        address2: '',
        country: null,
        city: null,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selected) => {
        setFormData(prev => ({ ...prev, type: selected }));
    };

    const handleAddOrUpdate = () => {

        if (editIndex !== null) {
            // UPDATE
            const updatedList = [...addressList];
            updatedList[editIndex] = formData;
            setAddressList(updatedList);
            setEditIndex(null);
        } else {
            // ADD
            setAddressList(prev => [...prev, formData]);
        }

        setFormData({
            type: null,
            poBox: '',
            address1: '',
            address2: '',
            country: null,
            city: null,
        });
    };

    const handleEdit = (index) => {
        setFormData(addressList[index]);
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        const filtered = addressList.filter((_, i) => i !== index);
        setAddressList(filtered);
    };

    const handleCountryChange = async (selectedOption) => {
        setCityList([])
        const params = new URLSearchParams();
        params.append('DropdownFor', 'CustCityDescByCountry');
        params.append('CascadText', selectedOption?.label);
        setFormData(prev => ({ ...prev, country: selectedOption, city: null }));
        const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
        setCityList(res?.data?.items)
    }
    const handleCityChange = (selectedOption) => {
        setFormData(prev => ({ ...prev, city: selectedOption }));
    }

    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>
                {!readOnly && (
                <>
                <div className="form-group grid-contain ">
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Type</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={addAddressType?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.type}
                            onChange={handleSelectChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">P.O.Box</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="poBox"
                            value={formData.poBox}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Country</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={formData?.country}
                            onChange={handleCountryChange}
                            options={countriesList?.map(country => ({ value: country?.value, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Address</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="address1"
                            value={formData.address1}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Address</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="address2"
                            value={formData.address2}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">City</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={formData?.city}
                            onChange={handleCityChange}
                            options={cityList?.map(country => ({ value: country?.value, label: country?.text }))}
                        />
                    </div>
                </div>
                <div className='my-4'>
                    <div
                        className='mainbtnSecondary flex-end gap-2 col-2'
                        style={{ cursor: "pointer" }}
                        onClick={handleAddOrUpdate}
                    >
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            {editIndex !== null ? "Update Contact" : "Add Contact"}
                        </div>
                    </div>
                </div>
                </>
                )}

                <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                {!readOnly && <th>Action</th>}
                                <th>Type</th>
                                <th>P.O.Box</th>
                                <th>Address 1</th>
                                <th>Address 2</th>
                                <th>City</th>
                                <th>Country</th>
                            </tr>
                        </thead>
                        <tbody>
                            {addressList.map((data, index) => (
                                <tr key={index}>
                                    {!readOnly && (
                                    <td className="text-center d-flex gap-3">
                                        <div className='center mt-2'>
                                            <FaEdit
                                                size={20}
                                                style={{ cursor: "pointer", color: "black" }}
                                                onClick={() => handleEdit(index)}
                                            />
                                        </div>
                                        <div className='center mt-2'>
                                            <FaTrash
                                                size={20}
                                                style={{ cursor: "pointer", color: "red" }}
                                                onClick={() => handleDelete(index)}
                                            />
                                        </div>
                                    </td>
                                    )}
                                    <td>{data.type?.label}</td>
                                    <td>{data.poBox}</td>
                                    <td>{data.address1}</td>
                                    <td>{data.address2}</td>
                                    <td>{data.city?.label}</td>
                                    <td>{data.country?.label}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default AddressDetails;
